export default "__VITE_ASSET__062ea246__"